import styled from "styled-components";
import { theme } from "uikit";

const Bind = styled.div`
	font-family: Lato;
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 16px;

	color: ${theme.colors.secondary};
`;

export default Bind;
